module.exports = __webpack_public_path__ + "img/arrow-left-1.4a7a9f48.svg";